import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartModule } from 'angular-highcharts';
import { TooltipModule } from 'ng2-tooltip-directive';
import { MaterialModule } from '../material/material.module';
import { AbsPipe } from './abs.pipe';
import { AddMinutesPipe } from './add-minutes.pipe';
import { AgoPipe } from './ago.pipe';
import { ChargeTypePipe } from './charge-type.pipe';
import { CommitmentCalendarComponent } from './commitment-calendar/commitment-calendar.component';
import { ConditionalSlicePipe } from './conditional-slice.pipe';
import { ConfirmActionDialogComponent } from './confirm-action-dialog/confirm-action-dialog.component';
import { CurrencyInPenniesPipe } from './currency-in-pennies.pipe';
import { DashIfNothingPipe } from './dash-if-nothing.pipe';
import { EarningsChartComponent } from './earnings-chart/earnings-chart.component';
import { FeatureFlagDirective } from './feature-flag.directive';
import { FooterComponent } from './footer/footer.component';
import { FromNowPipe } from './from-now.pipe';
import { ImageLightboxComponent } from './image-lightbox/image-lightbox.component';
import { InProgressLoadByPhonePipe } from './in-progress-load.pipe';
import { InThePastPipe } from './in-the-past.pipe';
import { JoinWithAndPipe } from './join-with-and.pipe';
import { JoinWithKeyPipe } from './join-with-key.pipe';
import { LoaderDialogComponent } from './loader-dialog/loader-dialog.component';
import { LoadsChartComponent } from './loads-chart/loads-chart.component';
import { MaxPipe } from './max.pipe';
import { CurrencyInputDirective } from './money.directive';
import { MonthNamePipe } from './month-name.pipe';
import { NumberBadgeComponent } from './number-badge/number-badge.component';
import { NumberInputDirective } from './number-input.directive';
import { OperationalPipe } from './operational.pipe';
import { OrdinalPipe } from './ordinal.pipe';
import { PageTitleDirective } from './page-title.directive';
import { PhonePipe } from './phone.pipe';
import { PieChartComponent } from './pie-chart/pie-chart.component';
import { PrettyPrintMinutesPipe } from './pretty-print-minutes.pipe';
import { PrettyPrintSecondsPipe } from './pretty-print-seconds.pipe';
import { ShiftMapComponent } from './shift-map/shift-map.component';
import { ShortNamePipe } from './shortName.pipe';
import { SortIndicatorComponent } from './sort-indicator/sort-indicator.component';
import { StandardDateOnlyPipe } from './standard-date-only.pipe';
import { StandardDatePipe } from './standard-date.pipe';
import { StandardTimePipe } from './standard-time.pipe';
import { TopnavComponent } from './topnav/topnav.component';
import { TrackByKey } from './track-by.pipe';
import { UserFromPhonePipe } from './user-from-phone.pipe';

const tooltipOptions = {
  'tooltip-class': 'tooltip-overrides',
};

@NgModule({
  declarations: [
    TrackByKey,
    StandardDatePipe,
    InProgressLoadByPhonePipe,
    PhonePipe,
    FeatureFlagDirective,
    DashIfNothingPipe,
    ImageLightboxComponent,
    NumberInputDirective,
    OperationalPipe,
    LoadsChartComponent,
    NumberBadgeComponent,
    CurrencyInputDirective,
    EarningsChartComponent,
    PrettyPrintMinutesPipe,
    CurrencyInPenniesPipe,
    PieChartComponent,
    AgoPipe,
    SortIndicatorComponent,
    AbsPipe,
    FromNowPipe,
    PageTitleDirective,
    MaxPipe,
    ConditionalSlicePipe,
    OperationalPipe,
    CommitmentCalendarComponent,
    MonthNamePipe,
    JoinWithAndPipe,
    ShiftMapComponent,
    StandardTimePipe,
    InThePastPipe,
    StandardDateOnlyPipe,
    AddMinutesPipe,
    PrettyPrintSecondsPipe,
    OrdinalPipe,
    UserFromPhonePipe,
    ChargeTypePipe,
    TopnavComponent,
    FooterComponent,
    ShortNamePipe,
    JoinWithKeyPipe,
    LoaderDialogComponent,
    ConfirmActionDialogComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ChartModule,
    TooltipModule.forRoot(tooltipOptions),
  ],
  exports: [
    TrackByKey,
    StandardDatePipe,
    InProgressLoadByPhonePipe,
    PhonePipe,
    FeatureFlagDirective,
    DashIfNothingPipe,
    OperationalPipe,
    EarningsChartComponent,
    NumberInputDirective,
    NumberBadgeComponent,
    PrettyPrintMinutesPipe,
    AgoPipe,
    FromNowPipe,
    PieChartComponent,
    AbsPipe,
    PageTitleDirective,
    LoadsChartComponent,
    CurrencyInPenniesPipe,
    SortIndicatorComponent,
    ChartModule,
    CurrencyInputDirective,
    TooltipModule,
    MaxPipe,
    ConditionalSlicePipe,
    CommitmentCalendarComponent,
    MonthNamePipe,
    JoinWithAndPipe,
    ShiftMapComponent,
    StandardTimePipe,
    InThePastPipe,
    StandardDateOnlyPipe,
    AddMinutesPipe,
    PrettyPrintSecondsPipe,
    OrdinalPipe,
    UserFromPhonePipe,
    ChargeTypePipe,
    TopnavComponent,
    FooterComponent,
    ShortNamePipe,
    JoinWithKeyPipe,
    LoaderDialogComponent,
    ConfirmActionDialogComponent,
  ],
  providers: [CurrencyInPenniesPipe, JoinWithKeyPipe],
})
export class SharedModule {}
